<script>
	import router from "./stores/router";
	import base from "./stores/base";
	import view from "./stores/view";
	import route from "./assets/route.json";

	import UITop from "./ui/UITop.svelte";
	import Modal from "./ui/modal/Modal.svelte";
	import Footer from "./ui/footer/Footer.svelte";
	import Header from "./ui/header/Header.svelte";

	import PageHome from "./pages/PageHome.svelte";
	import PageAbout from "./pages/PageAbout.svelte";
	import PageContact from "./pages/PageContact.svelte";
	import PageList from "./pages/PageList.svelte";
	import PageItem from "./pages/PageItem.svelte";
	import Page404 from "./pages/Page404.svelte";

	// ルーティング処理
	const pageComponents = {
		PageHome,
		PageAbout,
		PageContact,
		PageList,
		PageItem,
		Page404,
	};
	router.init(
		route.routes.map(({ path, title, component }) => ({
			path,
			title,
			component: pageComponents[component],
		})),
		route.info.siteName,
		process.env.APP_GA4_ID,
		process.env.APP_GA_ID,
	);
	router.subscribe((state) => {
		// console.log("$router", state);
		view.resetScroll();
	});

	// レスポンシブ処理
	view.subscribe((state) => {
		if (document.body.className !== state.className) {
			document.body.className = state.className;
		}
	});

	// サイト構造読み込み
	base.init(process.env.APP_API + "/base/detail");
</script>

{#if $base.isReady}
	<Modal />
	<UITop />
	<Header />
	<svelte:component this={$router.route.component} />
	<Footer />
{/if}

<style>
	:global(body.s) {
		font-size: 1.4rem;
	}
	:global(body.m) {
		font-size: 1.5rem;
	}
	:global(body.l) {
		font-size: 1.6rem;
	}
	:global(body.sp > main) {
		min-height: calc(100vh - 200px);
		padding-top: 60px;
	}
	:global(body.pc > main) {
		min-height: calc(100vh - 200px);
		padding-top: 100px;
	}
</style>
